import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"id":"municipio-select","item-text":"nome","item-name":"municipioId","items":_vm.municipios,"label":_vm.isParceiro
      ? 'Parceiros'
      : _vm.isSala
      ? 'Salas'
      : _vm.isGov
      ? 'Projetos'
      : 'Municípios',"placeholder":_vm.isParceiro
      ? 'Parceiros'
      : _vm.isSala
      ? 'Salas'
      : _vm.isGov
      ? 'Projetos'
      : 'Municípios',"multiple":"","return-object":true,"disabled":_vm.disabled,"clearable":""},on:{"change":function($event){return _vm.$emit('changeCity', _vm.filter.municipio)}},scopedSlots:_vm._u([{key:"selection",fn:function({ item, index }){return [(index < _vm.maxDisplay)?_c(VChip,_vm._b({attrs:{"small":""}},'v-chip',item,false),[_c('span',[_vm._v(_vm._s(item.nome))])]):_vm._e(),(index === _vm.maxDisplay)?_c('span',{staticClass:"grey--text caption"},[_vm._v("(+"+_vm._s(_vm.filter.municipio.length - _vm.maxDisplay)+"\n      "+_vm._s(_vm.isParceiro
          ? "Parceiros"
          : _vm.isSala
          ? "Salas"
          : _vm.isGov
          ? "Projetos"
          : "Municípios")+")")]):_vm._e()]}}]),model:{value:(_vm.filter.municipio),callback:function ($$v) {_vm.$set(_vm.filter, "municipio", $$v)},expression:"filter.municipio"}},[_c('div',{staticStyle:{"display":"flex","padding":"0 16px","cursor":"pointer"},attrs:{"slot":"prepend-item","ripple":""},on:{"click":_vm.toggle},slot:"prepend-item"},[_c('div',{staticStyle:{"margin-right":"32px"}},[_c(VIcon,{attrs:{"color":_vm.filter.municipio.length > 0 ? 'indigo darken-4' : ''}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',[_vm._v("Todos")])]),_c(VDivider,{staticClass:"mt-2",attrs:{"slot":"prepend-item"},slot:"prepend-item"}),_c('template',{slot:"no-data"},[_vm._v("\n    Nenhum\n    "+_vm._s(_vm.isParceiro
        ? "Parceiros"
        : _vm.isSala
        ? "Salas"
        : _vm.isGov
        ? "Projetos"
        : "Municípios")+"\n    retornado\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }